"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var react_truncate_1 = require("react-truncate");
var patchIcon_1 = require("../../utils/patchIcon");
var fileInfo_1 = require("./fileInfo");
var S_DEVICE_BREAKPOINT = 480;
var M_DEVICE_BREAKPOINT = 768;
var L_DEVICE_BREAKPOINT = 1152;
var XS_TRUNCATE_WIDTH = 180;
var S_TRUNCATE_WIDTH = 250;
var M_TRUNCATE_WIDTH = 270;
var L_TRUNCATE_WIDTH = 280;
var propTypes = {
    fileSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fileType: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string.isRequired
};
// Implementation taken from https://stackoverflow.com/a/18650828
var getHumanReadableFileSize = function (fileSize) {
    if (typeof fileSize === 'number') {
        var i = Math.floor(Math.log(fileSize) / Math.log(1024));
        var sizes = ['b', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        // toFixed(2) generates a string with exactly two fraction digits. To cut
        // off trailing zeros, we parse this string to a number. When coercing this
        // number to a string, no trailing zeros are shown.
        var convertedSize = parseFloat((fileSize / Math.pow(1024, i)).toFixed(2));
        return convertedSize.toString(10).replace('.', ',') + " " + sizes[i];
    }
    return fileSize;
};
/**
 * The `DownloadButton` is used for document downloads.
 */
var DownloadButton = /** @class */ (function (_super) {
    __extends(DownloadButton, _super);
    function DownloadButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleResize = function () {
            return _this.setState(function () { return ({
                windowSize: window.innerWidth
            }); });
        };
        _this.onClick = function (e) {
            if (_this.props.disabled) {
                e.preventDefault();
            }
            if (typeof _this.props.onClick === 'function') {
                _this.props.onClick(e);
            }
        };
        _this.calculateTruncateWidth = function () {
            var windowSize = _this.state.windowSize;
            if (windowSize >= L_DEVICE_BREAKPOINT) {
                return L_TRUNCATE_WIDTH;
            }
            if (windowSize >= M_DEVICE_BREAKPOINT) {
                return M_TRUNCATE_WIDTH;
            }
            if (windowSize >= S_DEVICE_BREAKPOINT) {
                return S_TRUNCATE_WIDTH;
            }
            return XS_TRUNCATE_WIDTH;
        };
        _this.state = {
            windowSize: window.innerWidth
        };
        return _this;
    }
    DownloadButton.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize);
    };
    DownloadButton.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    DownloadButton.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, disabled = _a.disabled, className = _a.className, href = _a.href, fileSize = _a.fileSize, fileType = _a.fileType, other = __rest(_a, ["children", "id", "disabled", "className", "href", "fileSize", "fileType"]);
        var componentClassName = classNames('ee_download-button', className);
        var fileInfo = fileInfo_1.default(fileType);
        var icon = patchIcon_1.default(fileInfo.icon, {
            className: 'ee_download-button__icon',
            width: 24,
            height: 24
        });
        var fileInfoTextSnippets = [];
        if (fileInfo.name) {
            fileInfoTextSnippets.push(fileInfo.name);
        }
        if (fileSize) {
            fileInfoTextSnippets.push(getHumanReadableFileSize(fileSize));
        }
        var fileInfoText = fileInfoTextSnippets.join(' ');
        return (React.createElement("a", __assign({ id: id, "data-focus-id": id, href: disabled ? undefined : href, className: componentClassName, "aria-disabled": disabled, onClick: this.onClick, download: true }, other),
            React.createElement("span", { className: "ee_download-button__icon-wrapper" }, icon),
            React.createElement("span", { className: "ee_download-button__text-wrapper" },
                React.createElement("span", { className: "ee_download-button__text" },
                    React.createElement(react_truncate_1.default, { width: this.calculateTruncateWidth(), lines: 2 }, children)),
                fileInfoText && (React.createElement("span", { className: "ee_download-button__file-information" }, fileInfoText)))));
    };
    DownloadButton.propTypes = propTypes;
    DownloadButton.defaultProps = {
        fileSize: undefined,
        fileType: undefined,
        href: undefined,
        disabled: undefined
    };
    return DownloadButton;
}(react_1.Component));
exports.DownloadButton = DownloadButton;
exports.default = DownloadButton;
//# sourceMappingURL=DownloadButton.js.map
